
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-phosphor-icons/-embroider-implicit-modules.js";
import "ember-primitives/-embroider-implicit-modules.js";
import "ember-route-template/-embroider-implicit-modules.js";
import "@ember/test-helpers/-embroider-implicit-modules.js";
import "@ember/test-waiters/-embroider-implicit-modules.js";
import "@embroider/legacy-inspector-support/-embroider-implicit-modules.js";
import "@embroider/router/-embroider-implicit-modules.js";
import "@fortawesome/ember-fontawesome/-embroider-implicit-modules.js";
import "@glimmer/component/-embroider-implicit-modules.js";
import "@html-next/vertical-collection/-embroider-implicit-modules.js";
import "@nullvoxpopuli/ember-composable-helpers/-embroider-implicit-modules.js";
import "@warp-drive/ember/-embroider-implicit-modules.js";
import "ember-basic-dropdown/-embroider-implicit-modules.js";
import "ember-changeset/-embroider-implicit-modules.js";
import "ember-changeset-validations/-embroider-implicit-modules.js";
import "ember-cli-babel/-embroider-implicit-modules.js";
import "ember-cli-deprecation-workflow/-embroider-implicit-modules.js";
import "ember-cli-page-object/-embroider-implicit-modules.js";
import "ember-concurrency/-embroider-implicit-modules.js";
import "ember-data/-embroider-implicit-modules.js";
import "ember-drag-drop/-embroider-implicit-modules.js";
import "ember-file-upload/-embroider-implicit-modules.js";
import "ember-inflector/-embroider-implicit-modules.js";
import "ember-intl/-embroider-implicit-modules.js";
import "ember-keyboard/-embroider-implicit-modules.js";
import "ember-lifeline/-embroider-implicit-modules.js";
import "ember-page-title/-embroider-implicit-modules.js";
import "ember-power-select/-embroider-implicit-modules.js";
import "ember-power-select-with-create/-embroider-implicit-modules.js";
import "ember-qunit/-embroider-implicit-modules.js";
import "ember-simple-auth/-embroider-implicit-modules.js";
import "ember-sinon-qunit/-embroider-implicit-modules.js";
import "ember-source/-embroider-implicit-modules.js";
import "ember-truth-helpers/-embroider-implicit-modules.js";
import "ember-window-mock/-embroider-implicit-modules.js";
import "tracked-built-ins/-embroider-implicit-modules.js";
import "ember-cli-content-security-policy/-embroider-implicit-modules.js";
import "ember-cli-inject-live-reload/-embroider-implicit-modules.js";
import "ember-auto-import/-embroider-implicit-modules.js";
import "@ember-intl/v1-compat/-embroider-implicit-modules.js";
import "ember-template-imports/-embroider-implicit-modules.js";
import "ember-cli-code-coverage/-embroider-implicit-modules.js";
import "@embroider/macros/-embroider-implicit-modules.js";
import "@glimmer/tracking/-embroider-implicit-modules.js";
import "@sentry/ember/-embroider-implicit-modules.js";
import "ember-cli-htmlbars/-embroider-implicit-modules.js";
import "ember-ref-bucket/-embroider-implicit-modules.js";
import "ember-bootstrap/-embroider-implicit-modules.js";
import "ember-bootstrap-changeset-validations/-embroider-implicit-modules.js";
import "ember-cli-bundlesize/-embroider-implicit-modules.js";
import "ember-cli-dependency-checker/-embroider-implicit-modules.js";
import "ember-cli-dependency-lint/-embroider-implicit-modules.js";
import "ember-cli-deploy/-embroider-implicit-modules.js";
import "ember-cli-deploy-brotli/-embroider-implicit-modules.js";
import "ember-cli-deploy-build/-embroider-implicit-modules.js";
import "ember-cli-deploy-display-revisions/-embroider-implicit-modules.js";
import "ember-cli-deploy-gzip/-embroider-implicit-modules.js";
import "ember-cli-deploy-revision-data/-embroider-implicit-modules.js";
import "ember-test-selectors/-embroider-implicit-modules.js";
import "ember-cli-sass/-embroider-implicit-modules.js";
import "ember-cli-segment/-embroider-implicit-modules.js";
import "ember-exam/-embroider-implicit-modules.js";
import "ember-notify/-embroider-implicit-modules.js";
import "ember-qunit-nice-errors/-embroider-implicit-modules.js";
import "ember-svg-jar/-embroider-implicit-modules.js";
import "ember-wormhole/-embroider-implicit-modules.js";
import "loader.js/-embroider-implicit-modules.js";
import "qunit-console-grouper/-embroider-implicit-modules.js";
